import { createSlice } from "@reduxjs/toolkit";

const cartSlice = createSlice({
  name: "cart",
  initialState: {
    cart: [],
    openCart: false,
    tendered: 0,
    payment_method: "Cash",
    purchaser: "",
  },
  reducers: {
    addToCart: (state, action) => {
      state.cart = [...state.cart, action.payload];
    },
    addToPrint: (state, action) => {
      state.cart = action.payload.items.map((item) => ({
        ...item,
        item_name: item.name,
        price: item.price / item.quantity,
        cost: item.price,
      }));
      state.tendered = action.payload.tendered;
      state.payment_method = action.payload.payment_method;
      state.purchaser = action.payload.purchaser;
    },
    removeItemFromCart: (state, action) => {
      state.cart = action.payload;
    },
    toggleCart: (state) => {
      state.openCart = !state.openCart;
    },
    tenderedAmount: (state, action) => {
      state.tendered = action.payload;
    },
    purchaserName: (state, action) => {
      state.purchaser = action.payload;
    },
    setPaymentMethod: (state, action) => {
      state.payment_method = action.payload;
    },
    resetCart: (state) => {
      state.cart = [];
      state.tendered = 0;
      state.payment_method = "Cash";
      state.purchaser = "";
      state.openCart = false;
    },
    increaseCartItemQuantity: (state, action) => {
      state.cart = action.payload;
    },
    decreaseCartItemQuantity: (state, action) => {
      state.cart = action.payload;
    },
  },
});

export const {
  addToCart,
  resetCart,
  toggleCart,
  removeItemFromCart,
  increaseCartItemQuantity,
  decreaseCartItemQuantity,
  tenderedAmount,
  setPaymentMethod,
  purchaserName,
  addToPrint,
} = cartSlice.actions;
export default cartSlice.reducer;
